var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chats-container",class:[_vm.size ? 'chats-container--' + _vm.size : '', _vm.addBottomClass ? 'chats-container--bottom' : '']},[_c('ChatsList',{attrs:{"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }